import EfsTippy from "components/HOCS/EfsTippy";
import ArrowExpand from "graphics/icons/MediaControls/SpaceControls/ArrowExpand";
import React from "react";
import { useSelector } from "react-redux";
import { selectInThisSpace } from "slices/sharedSelectors";
import { selectSpaceBoxActive, toggleSpaceBox } from "slices/spaceMediaSlice";
import { selectSpaceNode } from "slices/spaceSlice";

const ChangeSpaceActive = () => {
  const spaceBoxActive = useSelector(selectSpaceBoxActive);
  const spaceName = useSelector((state) => selectSpaceNode(state)?.content);
  const inThisSpace = useSelector(selectInThisSpace);

  if (inThisSpace && spaceBoxActive) return null;
  return (
    <EfsTippy
      content={`${spaceBoxActive ? "Hide Space" : "Show Current Space"}`}
      placement={spaceBoxActive ? "bottom" : "left"}
      className="small-Tippy grey-Tippy"
      offset={spaceBoxActive ? [0, 10] : [0, 0]}
      delay={[0, 0]}
    >
      <button
        className={`effice-to-space ${spaceBoxActive ? "to-right" : ""}`}
        onClick={toggleSpaceBox}
      >
        <span className={`space-side-arrow`}>
          <ArrowExpand />
        </span>
        {!spaceBoxActive ? (
          <span className={`space-side-info`}>
            <div className="space-side-help">You Are Inside</div>
            <div className="space-side-name dotdotdot">{spaceName}</div>
          </span>
        ) : (
          <span className={`space-side-info`}>Hide</span>
        )}
      </button>
    </EfsTippy>
  );
};

export default ChangeSpaceActive;
